// ApplicationModule.tsx
import React, { useEffect } from 'react';
import Module from './components/Module';
import { modulesData } from './components/index';
import { useTranslation } from 'react-i18next';
import Navbar from '../../layouts/NavBar/Navbar';
import { accessibleModules } from '../../services/AccountServices';
import { toast } from 'react-toastify';
import { useGlobalContext, UserRole } from '../../contexts/GlobalContext';

const AccessibleModules: React.FC = () => {
  const { t } = useTranslation();
  const title = `${t('accessible_modules', 'Accessible Modules')}`;
  const desc = `${t('select_a_module', 'Select a module')}`;
  const { userRole } = useGlobalContext();
  const [updatedModulesData, setUpdatedModulesData] = React.useState<any[]>([]);
  const defaultModulesData = modulesData.slice(0, 2);
  const supplierModule = modulesData[2];
  const edmsModule = modulesData[3];
  const supplierModuleAccessibleRoles: UserRole[] = [
    'UnverifiedSupplier',
    // 'Supplier',
    'System User',
  ];
  const isSupplierModuleAccessible = supplierModuleAccessibleRoles.includes(userRole as UserRole);
  const edmsAccessibleRoles: UserRole[] = ['Regulator', 'System User', 'Admin'];
  const isEdmsAccessible = edmsAccessibleRoles.includes(userRole as UserRole);

  const fetchAccessibleModules = async () => {
    try {
      const response = await accessibleModules();
      if (response?.isSuccess) {
        const mappedModules = response.data.map((module: any, index: number) => ({
          id: isSupplierModuleAccessible ? index + 4 : index + 3,
          imageSrc: `${process.env.PUBLIC_URL}/assets/images/chooseDemo/operator-icon.svg`,
          moduleTitle: `Module ${isSupplierModuleAccessible ? index + 4 : index + 3}`,
          moduleType: module.menuName,
          link: module.menuUrl,
          external: module.external ?? false,
        }));

        const mergedData = isSupplierModuleAccessible
          ? [...defaultModulesData, supplierModule, ...mappedModules]
          : [...defaultModulesData, ...mappedModules];
        if (isEdmsAccessible) {
          edmsModule.id = mergedData.length + 1;
          edmsModule.moduleTitle = `Module ${mergedData.length + 1}`;
          mergedData.push(edmsModule);
        }
        setUpdatedModulesData(mergedData);
      } else {
        const unverifiedUserModules = [...defaultModulesData, supplierModule];
        setUpdatedModulesData(unverifiedUserModules);
      }
    } catch (error: any) {
      toast.error(error);
    }
  };

  useEffect(() => {
    fetchAccessibleModules();
  }, []);

  return (
    <>
      <Navbar />
      <Module title={title} desc={desc} modulesData={updatedModulesData} />
    </>
  );

  // const [filteredModulesData, setFilteredModulesData] = useState(modulesData);

  // useEffect(() => {
  //   const fetchMenuData = async () => {
  //     try {
  //       const response = await myMenu();
  //       if (response.isSuccess) {
  //         const accessibleMenuIds = response.data.map((menu: any) => menu.menuId);
  //         const filteredData = modulesData.filter((module: any) =>
  //           accessibleMenuIds.includes(module.menuId)
  //         );
  //         setFilteredModulesData(filteredData);
  //       } else {
  //         console.error(response.errorMessage);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching menu data:', error);
  //     }
  //   };

  //   fetchMenuData();
  // }, []);

  // return <Module title={title} desc={desc} modulesData={filteredModulesData} />;
};

export default AccessibleModules;
